export type OptimizationRouteMode =
  | 'management'
  | 'legacy'
  | 'loading'
  | 'disabled';

export const getOptimizationRouteMode = (
  isScenarioManagementEnabled: boolean | undefined,
  isLegacyComparisonEnabled: boolean | undefined,
): OptimizationRouteMode => {
  if (isScenarioManagementEnabled === true) return 'management';
  if (isLegacyComparisonEnabled === undefined) return 'loading';
  return isLegacyComparisonEnabled ? 'legacy' : 'disabled';
};
